import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/uk.ts
var add = "Додати";
var remove = "Видалити";
var removeAll = "Видалити все";
var incomplete = "Вибачте, не всі поля заповнені правильно.";
var submit = "Відправити";
var noFiles = "Файл не вибрано";
var moveUp = "Рухатися вгору";
var moveDown = "Пересунути вниз";
var isLoading = "Завантаження...";
var loadMore = "Завантажте більше";
var next = "Наступний";
var prev = "Попередній";
var addAllValues = "Додати всі значення";
var addSelectedValues = "Додати вибрані значення";
var removeAllValues = "Вилучити всі значення";
var removeSelectedValues = "Вилучити вибрані значення";
var chooseDate = "Виберіть дату";
var changeDate = "Змінити дату";
var close = "Закрити";
var open = "Відкрити";
var accepted = function({
  name
}) {
  return `Будь ласка, прийміть ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `Дата ${sentence(name)} повинна бути пізніше за ${date(args[0])}.`;
  }
  return `Дата ${sentence(name)} має бути в майбутньому.`;
};
var alpha = function({
  name
}) {
  return `Поле ${sentence(name)} може містити лише літери.`;
};
var alphanumeric = function({
  name
}) {
  return `Поле ${sentence(name)} може містити лише літери та цифри.`;
};
var alpha_spaces = function({
  name
}) {
  return `Поле ${sentence(name)} може містити лише літери та пробіли.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} повинен містити алфавітні символи.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} повинен містити букви або цифри.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} повинен містити літери або пробіли.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} повинен містити символ.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} повинен містити великі регістри.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} повинен містити малі регістри.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} повинен містити цифри.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} має бути символом.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} може містити лише великі літери.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} може містити лише малі літери.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `Дата ${sentence(name)} повинна бути раніше за ${date(args[0])}.`;
  }
  return `Дата ${sentence(name)} повинна бути в минулому.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Це поле заповнено неправильно і не може бути надіслано.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `Поле ${sentence(name)} повинно бути між ${a} та ${b}.`;
};
var confirm = function({
  name
}) {
  return `Поле ${sentence(name)} не збігається.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `Поле ${sentence(name)} має неправильну дату. Будь ласка, використовуйте формат ${args[0]}.`;
  }
  return "Це поле заповнено неправильно і не може бути надіслано.";
};
var date_between = function({
  name,
  args
}) {
  return `Дата ${sentence(name)} повинна бути між ${date(args[0])} та ${date(args[1])}.`;
};
var email = "Будь ласка, введіть дійсну електронну адресу.";
var ends_with = function({
  name,
  args
}) {
  return `Поле ${sentence(name)} не повинно закінчуватися на ${list(args)}.`;
};
var is = function({
  name
}) {
  return `Поле ${sentence(name)} має неприпустиме значення.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `Поле ${sentence(name)} має містити щонайменше один символ.`;
  }
  if (min2 == 0 && max2) {
    return `Довжина поля ${sentence(name)} повинна бути меншою або дорівнювати ${max2} символам.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} має бути довжиною ${max2} символів.`;
  }
  if (min2 && max2 === Infinity) {
    return `Довжина поля ${sentence(name)} повинна бути більшою або дорівнювати ${min2} символам.`;
  }
  return `Довжина поля ${sentence(name)} повинна бути між ${min2} та ${max2} символами.`;
};
var matches = function({
  name
}) {
  return `Поле ${sentence(name)} має неприпустиме значення.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Не може бути вибрано більше ніж ${args[0]} ${name}.`;
  }
  return `Поле ${sentence(name)} має бути менше або дорівнювати ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Не вказано дозволені типи файлів.";
  }
  return `Тип файлу в полі ${sentence(name)} має бути: ${args[0]}.`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Не може бути вибрано менше ніж ${args[0]} ${name}.`;
  }
  return `Поле ${sentence(name)} має бути не менше ніж ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” не дозволено в полі ${name}.`;
};
var number = function({
  name
}) {
  return `Поле ${sentence(name)} має бути числом.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" або ")} потрібно.`;
};
var required = function({
  name
}) {
  return `Поле ${sentence(name)} є обов'язковим.`;
};
var starts_with = function({
  name,
  args
}) {
  return `Поле ${sentence(name)} має починатися з ${list(args)}.`;
};
var url = function() {
  return `Будь ласка, введіть коректну URL-адресу.`;
};
var invalidDate = "Вибрана дата недійсна.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var uk_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, uk_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=uk.mjs.map